<template>
  <div class="contract-detail">
    <el-collapse v-model="activeCollapses" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基础信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseInfoData"
            :columns="baseColumns"
            :isQueryPanel="false"
            labelWidth="150px"
            @changeMethod="changeValueHandler"
            :rules="tableRules"
          >
          </SiruiSearch>
        </div>
      </el-collapse-item>
      <!--附件-->
      <el-collapse-item name="5">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            v-if="statusName != '已生效' || origin == 'record'"
            ref="fileTableRef"
            :attachments="attachments"
            :isShowDownBtn="uploadDisabled"
            :isDisabledDelete="deleteFileDisabled"
          />
          <!-- 已生效状态下上传附件 -->
          <EffectiveFileTable
            v-else
            ref="fileTableRef"
            :attachments="attachments"
            :contractCode="baseInfoData.contractCode"
            :isShowDownBtn="uploadDisabled"
            @reloadPage="reloadPage1"
          ></EffectiveFileTable>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮 fixme需要判断立项状态显示-->
    <footer v-if="origin != 'record'" class="bottomButtons">
      <DetailFooterButtons
        @btnHandler="btnHandler"
        :pageMode="pageMode"
        :contractStatus="baseInfoData.contractStatus"
        :contractType="baseInfoData.contractType"
      />
    </footer>
    <CommonTextDialog ref="textDialog"></CommonTextDialog>
  </div>
</template>

<script>
  // import formItem from '../../common/components/form-item.vue';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  import { baseRules } from './columns/tableRules.js';
  // import FreightDetailChart from '@/pages/intermodality/common/charts/freightDetailChart/index.vue';
  // import RouteDetailChart from '@/pages/intermodality/common/charts/routeDetailChart/index.vue';
  // import ServiceFeeChart from '@/pages/intermodality/common/charts/serviceFeeChart/index.vue';
  // import AuditionRecordChart from '@/pages/intermodality/common/charts/auditionRecordChart/index.vue';
  import DetailFooterButtons from './components/DetailFooterButtons.vue';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import ContractServiceMixin from '@/pages/intermodality/otherContract/detail/mixins/ContractServiceMixin';
  import ContractFormStatusMixin from '@/pages/intermodality/otherContract/detail/mixins/ContractFormStatusMixin';
  import CommonTextDialog from '@/pages/intermodality/common/components/dialogs/CommonTextDialog';
  import FileTable from '@/components/business/FileTable/index.vue';
  import EffectiveFileTable from './components/effectiveFileTable/EffectiveFileTable.vue';
  // import EffectiveFileTable from './components/effectiveFileTable/EffectiveFileTable.vue';
  export default {
    name: 'otherContractCreation',
    mixins: [IntermodalityCommonMixin, ContractServiceMixin, ContractFormStatusMixin],
    components: {
      // FreightDetailChart,
      FileTable,
      // RouteDetailChart,
      // ServiceFeeChart,
      DetailFooterButtons,
      CommonTextDialog,
      // inputNumberAd,
      EffectiveFileTable,
    },
    data() {
      return {
        //0代表创建，1代表详情页查看状态，2代表详情页编辑状态
        activeTabName: 'freightAndRouteDetailTab',
        activeCollapses: ['1', '2', '3', '4', '5'],
        pageMode: 0,
        origin: '',
        isCustomerContract: true,
        statusName: '',
      };
    },
    computed: {
      tableRules() {
        return baseRules(this);
      },
    },
    methods: {
      concatReconcileLabel() {
        let label = '对账日期';
        if (this.getReconcilLabel() != '') {
          label = label + '    ';
          label = label + this.getReconcilLabel();
        }
        return label;
      },
      getReconcilLabel(isPrefix = true) {
        if (!this.baseInfoData.reconciliateRule) {
          if (isPrefix) {
            return '';
          } else {
            return '日';
          }
        } else {
          if (this.baseInfoData.reconciliateRule == '固定日期结算') {
            if (isPrefix) {
              return '每月';
            } else {
              return '日对账';
            }
          } else {
            if (isPrefix) {
              return '完成后';
            } else {
              return '日结算';
            }
          }
        }
      },
      clearValidate() {
        // this.$refs.productServiceRef.clearValidate();
        // this.$refs.reconciliationRef.clearValidate();
      },
      handleSwitchEditMode() {
        this.pageMode = this.pageMode == 1 ? 2 : 1;
        this.assignBaseColumnsStatus(this.baseInfoData);
        this.getProcessedBaseColumns(
          this.getStatusName('contract', this.baseInfoData.contractStatus),
          this.$route.query?.origin
        );
      },
      createSupplement() {
        let contractType = this.baseInfoData.contractType;
        if (contractType != '0') {
          this.$message({
            type: 'error',
            message:
              '新增失败！您选择的合同已为结算条款，不可再新增结算条款，请选择结算条款所属的常规合同进行结算条款维护',
          });
          return;
        }
        let params = {
          pageMode: 0,
          origin: 'supplement',
          contractCode: this.baseInfoData.contractCode,
        };
        this.toDetailPage(params);
      },
      async btnHandler(name, params) {
        let contractStatus = this.baseInfoData?.contractStatus;
        let contractCode = this.baseInfoData?.contractCode;
        let contractType = this.baseInfoData?.contractType;
        let statusName = this.getStatusName('contract', contractStatus);
        // this.statusName = this.getStatusName('contract', this.baseInfoData?.contractStatus);
        switch (name) {
          case 'revise':
            if ((await this.checkSupplementUnderApproval(contractCode)) == false) {
              this.$message({
                type: 'error',
                message: '该合同下结算条款未全部生效，无法补充协议，请检查！',
              });
              return;
            }
            this.handleSwitchEditMode();
            break;
          case 'save':
            //0保存1提交
            this.save(this.baseInfoData, params);
            break;
          case 'edit':
            this.handleSwitchEditMode();
            break;
          case 'view':
            this.handleSwitchEditMode();
            break;
          // case 'cancel':
          //   if (this.isCustomerContract) {
          //     this.$router.push({ path: '/intermodality/customerContract' });
          //   } else {
          //     this.$router.push({ path: '/intermodality/supplierContract' });
          //   }
          //   break;
          case 'delete':
            this.$confirmAction('删除合同确认', '是否确定要删除此合同？', '确认', '取消')
              .then(async () => {
                this.loading.startLoading();
                var res = await this.deleteContract();
                this.loading.endLoading();
                if (res.data.code == 0) {
                  this.$message.success(res.data.msg);
                  let path = `/intermodality/otherContract`;
                  this.$router.push({ path: path });
                } else {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: 'info',
                  message: '已取消',
                });
              });

            break;
          case 'activate':
            if (statusName != '已停用') {
              this.$message({
                type: 'error',
                message: '请选择一条已停用的数据',
              });
              return;
            }
            this.$confirmAction(`其他合同启用确认`, `是否确定要启用此其他合同?`, '确认启用', '取消')
              .then(async () => {
                this.handleUpdateStatus(true, contractCode, contractType);
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: 'info',
                  message: '已取消',
                });
              });
            break;
          case 'deactivate':
            if (statusName != '已生效') {
              this.$message({
                type: 'error',
                message: '请选择一条已生效的数据',
              });
              return;
            }
            this.$confirmAction(`其他合同停用确认`, '是否确定要停用此合同？', '确认停用', '取消')
              .then(async () => {
                this.handleUpdateStatus(false, contractCode, contractType);
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: 'info',
                  message: '已取消',
                });
              });
            break;
          default:
            break;
        }
      },

      async init() {
        await this.getDeptList();
        await this.getCommonDicts();
        await this.initDetail();
      },
      async reloadPage1() {
        await this.initDetail();
        console.log('reloadPage');
      },
    },
    mounted() {
      if (this.$route.query?.pageMode) {
        this.pageMode = Number(this.$route.query?.pageMode);
      }
      if (this.$route.query?.origin) {
        this.origin = this.$route.query?.origin;
      }
      let name = this.$route.name;
      this.isCustomerContract =
        name == 'customerContractDetail' ||
        name == 'customerContractCreation' ||
        name == 'customerContractHistoryDetail';

      console.log('isCustomerContract', this.isCustomerContract);
      this.init();
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }

  .footer-bottom-list {
    justify-content: center;
    display: flex;
    padding-top: 20px;
  }

  .bottomButtons {
    padding-top: 20px;
    text-align: center;
  }
</style>
